import { Link } from "react-router-dom";
import { works } from "../../../mocks/works";
import WorkCard from "../../../components/feature/WorkCard";

const hot = [...works].sort((a, b) => b.rating - a.rating).slice(0, 6);

export default function TopWorks() {
  const [first, ...rest] = hot;
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="text-xs font-semibold tracking-widest text-accent-500">HOT PICKS</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            本周热门同人推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-400">
            综合读者口碑与热度整理，发现当下最值得追更的同人作品。
          </p>
        </div>
        <Link
          to="/works"
          className="flex items-center gap-1 self-start text-sm text-primary-300 transition-colors hover:text-primary-400 whitespace-nowrap"
        >
          查看全部作品
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
        <Link
          to={`/work/${first.id}`}
          className="group relative col-span-1 flex min-h-[340px] flex-col justify-end overflow-hidden rounded-lg border border-background-300/60 bg-background-100 lg:col-span-2 lg:row-span-2"
        >
          <img
            src={first.cover}
            alt={`${first.title} 同人作品封面`}
            title={`${first.title} 热门火影忍者同人`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/55 to-transparent" />
          <div className="relative p-6 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-accent-500/90 px-2.5 py-1 text-xs font-semibold text-background-50">
                本周 TOP 1
              </span>
              <span className="rounded-md bg-background-50/70 px-2.5 py-1 text-xs text-foreground-800 backdrop-blur-sm">
                {first.status}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {first.title}
            </h3>
            <p className="mt-2 max-w-lg text-sm leading-relaxed text-foreground-300">
              {first.summary}
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-400">
              <span>@{first.author}</span>
              <span className="flex items-center gap-1"><i className="ri-book-open-line" />{first.chapters} 章</span>
              <span className="flex items-center gap-1"><i className="ri-eye-line" />{first.views}</span>
              <span className="flex items-center gap-1 text-primary-300"><i className="ri-star-fill" />{first.rating.toFixed(1)}</span>
            </div>
          </div>
        </Link>

        {rest.map((w, i) => (
          <div key={w.id} className="flex gap-3 rounded-lg border border-background-300/60 bg-background-100 p-3 transition-colors hover:border-primary-500/40">
            <Link to={`/work/${w.id}`} className="relative w-20 shrink-0 self-start overflow-hidden rounded-md">
              <img src={w.cover} alt={`${w.title} 同人作品封面`} title={`${w.title} 热门火影忍者同人`} loading="lazy" className="aspect-[3/4] w-full object-cover object-top" />
              <span className="absolute left-1 top-1 flex h-5 w-5 items-center justify-center rounded bg-accent-500 text-[11px] font-bold text-background-50">
                {i + 2}
              </span>
            </Link>
            <div className="flex flex-col">
              <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors hover:text-primary-300">
                <Link to={`/work/${w.id}`}>{w.title}</Link>
              </h3>
              <p className="mt-1 text-xs text-foreground-400">@{w.author}</p>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-300">
                {w.summary}
              </p>
              <div className="mt-auto flex flex-wrap items-center gap-3 pt-2 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-eye-line" />{w.views}</span>
                <span className="flex items-center gap-1 text-primary-300"><i className="ri-star-fill" />{w.rating.toFixed(1)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {hot.slice(0, 4).map((w) => (
          <div key={w.id} className="hidden rounded-lg border border-background-300/60 bg-background-100 p-3 sm:block">
            <div className="flex items-center gap-2">
              <img src={w.cover} alt="" className="h-8 w-8 rounded object-cover object-top" />
              <h4 className="truncate text-sm font-medium text-foreground-800">
                <Link to={`/work/${w.id}`} className="hover:text-primary-300">{w.title}</Link>
              </h4>
            </div>
            <p className="mt-2 text-xs text-foreground-400">{w.updated}</p>
          </div>
        ))}
      </div>
    </section>
  );
}